<template>
  <div>
    <template>
      <v-menu open-on-hover offset-y @click.native.stop.prevent key="print_cover">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="circle"
            outline
            :loading="loading"
            :disabled="loading"
            small
            fab
            color="primary"
            v-on="on"
            v-tooltip.top="$t('Print Cover')"
          >
            <span class="fa fa-print"></span>
          </v-btn>
          <v-btn
            v-else
            :loading="loading"
            :disabled="loading || orders.length == 0"
            outline
            color="grey"
            v-on="on"
          >
            <v-icon>fa fa-print</v-icon>
            &nbsp;{{ $t('Print Covers') }}
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-if="$store.state.centralPage.includes(selectedBot.pageid)"
            key="central"
            @click.stop="getShopProfile('central')"
          >
            <v-list-tile-title>ปริ้นใบปะหน้า Central</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="a5" @click.stop="getShopProfile('a5')">
            <v-list-tile-title>ปริ้นขนาดแบบเก่า A5</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="new-a5" @click.stop="getShopProfile('new-a5')">
            <v-list-tile-title>ปริ้นขนาด A5</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="a4" @click.stop="getShopProfile('a4')">
            <v-list-tile-title>ปริ้นขนาด A4</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="5.7mm" @click.stop="getShopProfile('5.7mm')">
            <v-list-tile-title>ปริ้นขนาด 5.7mm</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="5.7mm-detail" @click.stop="getShopProfile('5.7mm-detail')">
            <v-list-tile-title>ปริ้นขนาด 5.7mm รายละเอียด</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            key="billing"
            @click.stop="getShopProfile('billing')"
            v-if="selectedBot.pageid == '145969602635827'"
          >
            <v-list-tile-title>ปริ้นใบเสร็จ</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="a5-onlyAddress" @click.stop="getShopProfile('a5-onlyAddress')">
            <v-list-tile-title>ปริ้นขนาด A5 ผู้ส่ง-ผู้รับ</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
    <template v-if="false">
      <v-btn
        v-if="circle"
        outline
        :loading="loading"
        :disabled="loading"
        small
        fab
        color="primary"
        @click="getShopProfile('a5')"
        v-tooltip.top="$t('Print Cover')"
      >
        <span class="fa fa-print"></span>
      </v-btn>
      <v-btn
        v-else
        :loading="loading"
        :disabled="loading || orders.length == 0"
        outline
        color="grey"
        @click="getShopProfile('a5')"
      >
        <v-icon>fa fa-print</v-icon>
        &nbsp;{{ $t('Print Covers') }}
      </v-btn>
    </template>

    <v-dialog v-model="showEditAddress" width="800">
      <v-card v-if="showEditAddress">
        <v-card-text>
          <div style="text-align: right">
            <v-btn @click="cancelEdit" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <label for="pageAddress">{{ $t('Shop Address') }}</label>

          <shipping-address></shipping-address>
          <div class=" text-xs-center mt-3">
            <v-btn @click="skipEdit" outline color="grey">{{ $t('skip') }}</v-btn>
            <v-btn
              @click="saveContent"
              :loading="loadingsave"
              depressed
              color="primary"
              :disabled="!addresses || addresses.length == 0"
            >
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrintAllCovers from './PrintAllCovers.js'
export default {
  mixins: [PrintAllCovers]
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCovers.vue